// eslint-disable-next-line no-restricted-imports
import { DIALOG_STATE_KEY } from '../../../../routing/ModalRoute';
import { HistoryState } from '../typings';

export const pushDialogState = (dialogName: string, additionalState?: Record<string, unknown>) => {
    const state: HistoryState = {
        usr: {
            [DIALOG_STATE_KEY]: dialogName,
            ...additionalState,
        },
    };

    window.history.pushState(state, '', '');
};

export const replaceDialogState = (
    dialogName: string,
    additionalState?: Record<string, unknown>,
) => {
    const state: HistoryState = {
        usr: {
            [DIALOG_STATE_KEY]: dialogName,
            ...additionalState,
        },
    };

    window.history.replaceState(state, '', '');
};

export const goBack = (): void => {
    window.history.back();
};

export const extractDialogState = (event: PopStateEvent): HistoryState['usr'] | undefined =>
    event.state?.usr;
